import get from 'lodash/get';
import React from 'react';

import I18n from '../../i18n';
import AppContext from '../../services/Context';
import styled from '../../styled-components';
import Button from '../Button';

type PropType = {
  className?: string;
  name: string;
  items?: any;
  value?: any;
  withError?: boolean;
  disabled?: boolean;
  setFieldValue: Function;
  setTouched: Function;
  onFocus: Function;
  onBlur: Function;
};

const TextField = (props: PropType) => (
  <AppContext.Consumer>
    {({ theme, locale }) => (
      <InputWrapper
        theme={theme}
        className={`form-input-wrapper_${props.name} ${props.className || ''}`}
      >
        {props.items &&
          props.items.map((item: { value: string; label: string }) => (
            <Button
              key={`button-${item.value}`}
              className={`primary outline ${item.value === props.value ? 'active' : ''}`}
              onClick={(e: React.MouseEvent<HTMLElement>) => {
                e.preventDefault();
                if (item.value !== props.value) {
                  props.setFieldValue(props.name, item.value);
                  props.setTouched({ [props.name]: true });
                }
              }}

            >
              {I18n.l(item.label || '')}
            </Button>
          ))}
      </InputWrapper>
    )}
  </AppContext.Consumer>
);

const InputWrapper = styled.div`
  
  flex-flow: row nowrap;
  align-items: center;
  justify-content: space-between;
  ${({ theme }) => get(theme, 'form.inputWrapper')};

  &.search {
    ${({ theme }) => get(theme, 'form.searchWrapper')};
  }
  &.auth-style {
    ${({ theme }) => get(theme, 'form.authWrapper')};
  }

  button {
    border-radius: 0;
    padding: 10px;

    &:first-of-type {
      border-radius: 10px 0 0 10px;
       
    }
    &:last-of-type {
      border-radius: 0 10px 10px 0;
       border-left: 0px; 
    }
    &:not(.active) {
      color: #666;
      border-color: #666;
    }
  }
`;

export default TextField;
